/*
---
name: Limousine Widget
description: Autocompleter
authors:
- Anton Burov
license:
- MIT-style license
---
*/

/**
	Extends Limousine:
	when the instance has option 'submit_onenter = false',
	the user gets search results page entering the value in the field and hitting enter key,
	but if user after entering the value selects one of the items, it takes him to the item's page
*/

var LimousineExt = new Class({
	Extends: Limousine,

	build: function(){
		this.submit_onenter = this.options.submit_onenter;

		var opts = this.options,
				_self = this._element;

		this._field = _self.getElement(opts.textfield_selector);
		this._behind_field = _self.getElement('.w_limousine_autocomplete._behind');

		if(this._field){
			this._field.set('autocomplete', 'off').addClass(opts.cls+'_autocomplete');
			this._form = this._field.getParent('form');

			opts.over_text = this._field.getAttribute('data-overtext') || opts.over_text;

			if(opts.keyfield_selector){
				this._key_field = this._form.getElement(opts.keyfield_selector);

				if(opts.default_value){
					this._field.set('value', opts.default_value).removeClass('inactive');
				}

				if(Core.is_ie()){
					if(!this._field.get('value') || this._field.get('value') == ''){
						this._field.addClass('inactive').set('value', opts.over_text);
					}else{
						this._field.removeClass('inactive');
					}
				}else{
					this._field.set('placeholder', opts.over_text);
					opts.over_text = null;
				}
			}

			if(!opts._results){
				this._results_wrapper = new Element('.' + opts.cls + '_results_wrapper').inject(_self);
				this._results_scroller = new Element('.' + opts.cls + '_results_scroller').inject(this._results_wrapper);
				this._results = new Element('.' + opts.cls + '_results').inject(this._results_scroller);
			}else{
				this._results = opts._results;
			}

			var relay = ':relay('+opts.item_sel+')';
			var evts = {};
			evts['click'+relay] = this.handle_item_click.bind(this);
			evts['mouseenter'+relay] = this.handle_item_mouseover.bind(this);
			evts['mouseleave'+relay] = this.handle_item_mouseout.bind(this);

			this._results.addEvents(evts);

			if(this._results != null){
				this._results.fade('hide');
			}

			if(opts.cache){
				this.cache = [];
			}

			this.attach_textfield_events();
		}

		this.fireEvent('build', [this]);

		if(this._form){
			this._form.addEvent('submit', function(e){
				e.preventDefault();

				this.handle_enterkey(e);
			}.bind(this));
		}
	},

	handle_enterkey: function(e){
		var opts = this.options,
				_selected = this._results.getElement('.selected');

		if(_selected){
			this.submit_onenter = false;
			this.handle_item_click(e, _selected);
		}else{
			if(!this._results.getElement('.item')){
				if(this._field.get('value').length < 3){
					if(e && e.stop) e.stop();
				}else{
					this.submit_onenter = true;
				}

				return;
			}

			if(opts.custom_action == true){
				if(e && e.stop) e.stop();

				return;
			}else{
				this.submit_onenter = true;
			}
		}

		(function(){
			this.fireEvent('itemSelected', [this, _selected]);
		}.bind(this)).delay(20);

		this.handled = false;
	},

	handle_keydown: function(e){
		clearTimeout(this.timer);

		if(e && e.key) {
			switch (e.key) {
				case 'up': case 'down':
				 	if(!e.shift){
						this.navigate(e.key);
						this.fireEvent('textfieldKey'+e.key, [this]);
						return false;
					}
					break;

				case 'left': case 'right':
					this.fireEvent('textfieldKey'+e.key, [this]);
					break;
			 }
		 }

		 this.fireEvent('textfieldKeydown', [this, e.key]);

		 return true;
	},

	handle_item_click: function(e, _target){
		if(e){
			e.preventDefault();
		}

		var opts = this.options;

		if(opts.custom_action == true){
			this.fireEvent('runCustomAction', _target.getProperty('data-url'));
		}else{
			if(!_target) return;

			var value = _target.get('data-' + opts.item_value_field);

			if(value){
				if(this._field){
					this._field.set('value', value);
				}

				var key = _target.get('data-' + opts.item_key_field);

				if(this._key_field){
					this._key_field.set('value', key);
				}

				if(this._behind_field){
					this._behind_field.set('value', '');
				}
			}

			this.fireEvent('itemSelected', [this, _target]);

			var url = _target.get('data-' + opts.item_url_field);

			if(url){
				if(Page_on_hold.active){
					Page_on_hold.url = url;
					return;
				}

				window.location = url;
			}
		}
	}
});

var LimousineAnything = new Class({
	Extends: LimousineExt,
	Implements: [Options, Events],

	options: {
		delay: 150,
		request: 'json'
	},

	build: function(){
		this.parent();

		var self = this;

		if(this._field){
			var ev = ((Core.is_ie8() || Core.is_ie9()) ? 'change' : 'input');

			this._field.addEvent(ev, function(){
				var type_val = self._field.get('value');
				var auto_val = self._behind_field.get('value');

				var type_val_l = type_val.toLowerCase();
				var auto_val_l = auto_val.toLowerCase();

				if(type_val.length < auto_val.length){
					if(auto_val_l.substr(0, type_val.length) != type_val_l || type_val == ''){
						self._behind_field.set('value', '');
					}else{
						self._behind_field.set('value', type_val + auto_val.substr(type_val.length));
					}
				}
			});

			this.addEvent('clearResults', function(){
				self._field.fireEvent('clearResults');
			});
		}

		document.addEvent('click', function(e) {
			if(e && e.target && e.target.getParent && (e.target.getParent('.w_limousine') || e.target.hasClass('w_limousine'))) return;

			self.handle_blur(e, 0);
		});
	},

	handle_response: function(response, query_string){
		if(this._field.get('value').length < this.options.min_chars) return;

		this.clear_results();

		if(response.hood_top || response.property_top){
			this.auto_complete(query_string, (response.hood_top || response.property_top));
		}else{
			this.auto_complete(null, '');
		}

		var data = {
			hood: response.hood,
			property: response.property,
			partial: response.partial,
			links: response.links,
			ga: response.ga
		};

		var html = this.get_html(data);

		if(html == ''){
			this._field.fireEvent('clearResults');
			html = '<div class="no_results">No Matches Found. <span>Try neighborhood or building name (i.e. "Chelsea" or "Trump Tower")</span></div>';
		}else{
			this._field.fireEvent('gotResults');
			this._results_wrapper.addClass('has_results');
		}

		this._results.set('html', html);

		this.submit_url = this.get_submit_url();

		this._items = this._element.getElements('.items .item');

		var _fv = this._results.getElement('.field_value');
		if(_fv) _fv.set('text', this._field.get('value'));

		this._results.show();
		this._results.fade('show');

		this.add_nh_stats_support();
		this.click_on_property_link_support();
		this.click_on_search_link_support();
	},

	clear_results: function(){
		this._items = [];

		this.current_query_string = null;

		this._results.fade('hide');
		this._results_wrapper.removeClass('has_results');

		if(this._results.get('html') != ''){
			this._results.empty();
			this.fireEvent('clearResults', [this]);
		}

		return this;
	},

	add_nh_stats_support: function(){
		var self = this;

		this._items.each(function(_el){
			if(!_el || !_el.hasClass('_nh')) return;

			_el.addEvents({
				'mouseenter': function(){
					self.show_nh_stats(_el);
				},

				'mouseleave': function(){
					var _selected = self._element.getElement('.items .item.selected._nh');

					if(_selected){
						self.show_nh_stats(_selected);
					}else{
						self.show_init_nh_stats();
					}
				},

				'mouseover': function(){
					_el.fireEvent('mouseenter');
				},

				'mouseout': function(){
					_el.fireEvent('mouseleave');
				}
			});
		});
	},

	get_submit_url: function(){
		if(this._results.getElement('.hood_list')) return null;

		var _link = this._results.getElement('.all_results');

		if(!_link){
			_link = this._results.getElement('a');
		}

		return _link? _link.getAttribute('href') : null;
	},

	get_html: function(data){
		var links_html = this.get_links_html(data.links);
		var hoods_html = this.get_hoods_html(data.hood, data.partial, data.ga);
		var properties_html = this.get_properties_html(data.property, data.ga);

		return  links_html + hoods_html + properties_html;
	},

	get_links_html: function(data){
		var html = '';
		var opts = this.options;
		var query_string = this.get_query_string();
		var escape_query_string = RegExp.escape(query_string);

		if(!data || data.length == 0) return html;

		html += '<div class="link_list">' +
							'<ul class="items">';

		data.each(function(el) {
			var label = el.label.replace(new RegExp('(' + escape_query_string + ')', 'gi'), opts.highlight_markup.substitute({'query': '$1'}));
			html += '<li class="item"' + (el.url? (' data-url="' + el.url) : '') + '" data-value="' + el.label + '">' +
								(el.url? ('<a class="item_value" href="' + el.url + '">' + label + '</a>') : ('<span class="item_value">' + label + '</span>')) +
							'</li>';
		});

		html +=	'</ul></div>'

		return html;
	},

	get_hoods_html: function(data, partial, ga){
		var html = '';

		if(data.list.length == 0 && !partial){
			this._results.removeClass('_full');
		}else{
			var total = this.get_hoods_total(data.total, data.url, ga);

			var type = data.list[0]? data.list[0].type : 'hood';

			if(!partial){
				this._results.addClass('_full');
				var list = this.get_hoods_list(data.list, ga);

				html =	'<div class="hood_list">' +
									'<div class="header">' +
										(type == 'hood'? 'Neighborhood Information' : 'Matching Area(s)') +
									'</div>' +
									'<ul class="items">' +
										list +
									'</ul>' +
								'</div>';
			}

			html += total;
		}

		return html;
	},

	get_hoods_list: function(data, ga){
		var opts = this.options;
		var query_string = this.get_query_string();
		var html = '';
		var current_zone;
		var max_item = 6; //CRTWO-2841

		data.each(function(el, i){
			if(i > max_item-1) return;

			current_zone = (el.zone? current_zone : el.id);
			var escape_query_string = RegExp.escape(query_string);
			var label = el.name.replace(new RegExp('(' + escape_query_string + ')', 'gi'), opts.highlight_markup.substitute({'query': '$1'}));

			var trackHood = el.zone && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + el.url.query.action + '" data-track-label="' + ga.label + '" ' : '';

			html += '<li class="item _nh' + (!el.zone? ' _zone' : '') + ((el.zone && el.zone == current_zone)? ' _shift' : '') + (el.zone? ('"data-url="' + el.url.query.url + '" data-value="' + el.name) : '') + '" data-sale="' + el.for_sale + '" data-rent="' + el.for_rent + '" data-condos="' + el.condos_coops + '" data-nofee="' + el.rentals + '">' +
								(el.zone? '<a href="' + el.url.query.url + '"': '<span') + ' class="item_value" ' + trackHood + '>' + label + (el.zone? '</a>' : '</span>') +
							'</li>';
		});

		if(data.length > max_item){
			var trackAllHoods = ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="allneighborhoods" data-track-label="' + ga.label + '" ' : '';

			html += '<li class="item _all_nh" data-url="/nyc">' + '<a href="/nyc" class="item_value" ' + trackAllHoods + ' >' + 'View All Neighborhoods Matches' + '</a>' + '</li>';
		}

		return html;
	},

	get_hoods_total: function(data, url, ga) {
		var trackForSale = data.for_sale > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.for_sale.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackCondosCoop = data.condos_coops > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.condos_coops.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackForRent = data.for_rent > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.for_rent.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackRentals = data.rentals > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.rentals.action + '" data-track-label="' + ga.label + '" ' : '';

		var html =	'<table class="hood_total">' +
							'<tr>' +
								'<td class="sales">' +
									'<h3>Condos &amp; Co-ops - Sales</h3>' +

									'<table>' +
										'<tr>' +
											'<td class="_left">' +
												(data.for_sale > 0? ('<a class="stat" href="' + url.for_sale.url + '" ' + trackForSale + '>') : '<div class="stat">') +
													'<span data-initial-value="' + data.for_sale + '">' + Core.add_commas(data.for_sale) + '</span>Apts for Sale' +
												(data.for_sale > 0? '</a>' : '</div>') +
											'</td>' +

											'<td class="_right">' +
												(data.condos_coops > 0? ('<a class="stat" href="' + url.condos_coops.url + '" ' + trackCondosCoop + '>') : '<div class="stat">') +
													'<span data-initial-value="' + data.condos_coops + '">' + Core.add_commas(data.condos_coops) + '</span>Building Profiles' +
												(data.condos_coops > 0? '</a>' : '</div>') +
											'</td>' +
										'</tr>' +
									'</table>' +
								'</td>' +

								'<td class="gap"></td>' +

								'<td class="rentals _right">' +
									'<h3>Rentals</h3>' +

									'<table>' +
										'<tr>' +
											'<td class="_left">' +
												(data.for_rent > 0? ('<a class="stat" href="' + url.for_rent.url + '" ' + trackForRent + '>') : '<div class="stat">') +
													'<span data-initial-value="' + data.for_rent + '">' + Core.add_commas(data.for_rent) + '</span>Apts for Rent' +
												(data.for_rent > 0? '</a>' : '</div>') +
											'</td>' +

											'<td class="_right">' +
												(data.rentals > 0? ('<a class="stat" href="' + url.rentals.url + '" ' + trackRentals + '>') : '<div class="stat">') +
													'<span data-initial-value="' + data.rentals + '">' + Core.add_commas(data.rentals) + '</span>No Fee Buildings' +
												(data.rentals > 0? '</a>' : '</div>') +
											'</td>' +
										'</tr>' +
									'</table>' +
								'</div>' +
							'<tr>' +
						'</table>';

		return html;
	},

	get_properties_html: function(data, ga){
		var html = '';

		if(data.list.length == 0) return html;

		var trackTotalForSale = data.total.for_sale > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + data.url.for_sale.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackTotalForRent = data.total.for_rent > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + data.url.for_rent.action + '" data-track-label="' + ga.label + '" ' : '';

		html += '<table class="property_total">' +
							'<tr>' +
								'<td>' +
									(data.total.for_sale > 0? ('<a class="stat" href="' + data.url.for_sale.url + '" ' + trackTotalForSale + '>') : '<div class="stat">') +
										'<span>' + Core.add_commas(data.total.for_sale) + '</span>Apts for Sale' +
									(data.total.for_sale > 0? '</a>' : '</div>') +
								'</td>' +

								'<td class="gap"></td>' +

								'<td>' +
									(data.total.for_rent > 0? ('<a class="stat" href="' + data.url.for_rent.url + '" ' + trackTotalForRent + '>') : '<div class="stat">') +
										'<span>' + Core.add_commas(data.total.for_rent) + '</span>Apts for Rent' +
									(data.total.for_rent > 0? '</a>' : '</div>') +
								'</td>' +
							'</tr>' +
						'</table>';

		html += '<div class="property_list">' +
							'<div class="header">' +
								'Building' + (data.list.length > 1? 's' : '') + ' with \'<span class="field_value"></span>\' in name (' + data.list.length + (data.list.length == 15? '+' : '') + ')' +
							'</div>' +
							'<ul class="items">';


		var query_string = this.get_query_string();
		var escape_query_string = RegExp.escape(query_string);
		var opts = this.options;

		data.list.each(function(el){
			var label = el.name_display.replace(new RegExp('(' + escape_query_string + ')', 'gi'), opts.highlight_markup.substitute({'query': '$1'}));

			var tracking = el.action && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + el.action + '" data-track-label="' + ga.label + '" ' : '';

			html += '<li class="item"' + (el.url? (' data-url="' + el.url) : '') + '" data-value="' + el.name_address + '">' +
								(el.url ? ('<a class="item_value" href="' + el.url + '" ' + tracking + '>' + label + '</a>') : ('<span class="item_value">' + label + '</span>')) +
							'</li>';
		});

		var url = this._form.getAttribute('data-submit');

		if(query_string && query_string != '' && url && url != ''){
			url += query_string;
		}

		var trackingAllMatches = ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="allbuildings" data-track-label="' + ga.label + '" ' : '';
		html +=		'</ul>' +
							'<a class="view_all_results raquo' + (data.total.buildings == data.list.length? ' none' : '') + '" href="' + url + '" ' + trackingAllMatches + ' >View All Matches</a>' +
						'</div>';

		return html;
	},

	auto_complete: function(query_str, full_str){
		if(!this._behind_field) return;

		if (query_str && full_str) {
			query_str = query_str.toLowerCase();
			full_str = full_str.toLowerCase();
			if (full_str.indexOf(query_str) > -1) {
				full_str = query_str + full_str.substr(query_str.length);
				this._behind_field.set('value', (query_str === '' ? '' : full_str));
			} else {
				this._behind_field.set('value', '');
			}
		}
	},

	navigate: function(direction){
		this.parent(direction);

		if(this._selected_item){
			this.show_nh_stats(this._selected_item);
		}
	},

	show_nh_stats: function(_el){
		var _big_numbers = this._results.getElements('.hood_total table span');

		if(_big_numbers.length < 4) return;

		if(_el.hasClass('_nh')){
			var data = [
				_el.getAttribute('data-sale'),
				_el.getAttribute('data-condos'),
				_el.getAttribute('data-rent'),
				_el.getAttribute('data-nofee')
			];

			_big_numbers.each(function(_el, i){
				_el.set('html', Core.add_commas(data[i]));
			});
		}else{
			this.show_init_nh_stats();
		}
	},

	show_init_nh_stats: function(){
		var _big_numbers = this._results.getElements('.hood_total table span');

		_big_numbers.each(function(_el, i){
			_el.set('html',  Core.add_commas(_el.getAttribute('data-initial-value')));
		});
	},

	attach_textfield_events: function(){
		if(this._field != null){
			this._field.removeEvents().addEvents({
				keyup: this.handle_keyup.bind(this),
				keydown: this.handle_keydown.bind(this),
				blur: this.handle_blur.bind(this),
				focus: this.handle_focus.bind(this),
				click: this.handle_click.bind(this)
			});
		}
	},

	handle_blur: function(e, delay){
		delay = delay || 500;

		this.timer = this.clear_results.delay(delay, this);
		this.fireEvent('textfieldBlur', [this]);
	},

	handle_enterkey: function(e){
		if(this._field.get('value').length < this.options.min_chars) return;

		var url = this._form.getAttribute('data-submit');
		var query_string = this.get_query_string();
		if(query_string && query_string != '' && url && url != ''){
			url += query_string;
		}
		_gaq.push(['_trackEvent', 'autocomplete-click', 'search', 'keywords']);
		window.location = url;

		// var _items = this._results.getElements('.property_list .item');
		// if(!this._results.getElement('.hood_list') && _items.length == 1){
		// 	_items[0].addClass('selected');
		// 	this.parent();
		// }else if(this._results.getElement('.selected')){
		// 	this.parent();
		// }else{
		// 	this.do_query();
		// }
	},

	click_on_property_link_support: function(){
		// in IE8, clicking a building link from a autosearch widget,
		// HTTP_REFERER is empty thats why I'm using a cookie .
		// HTTP_REFERER is being use on promotab section on building overview page
		if(Core.is_ie8()){
			var _property_list = this._results.getElement('.property_list');

			if(!_property_list) return;

			_property_list.addEvents({
				'click:relay(a)': function(e, _el){
					Cookie.write('crReferer', 'cityrealty');
				}
			})
		}
	},

	click_on_search_link_support: function(){
		//set crSearchScrollPosition cookie to 0 so it will stay at the top of the page when we load the search result page.
		this._results.addEvents({
			'click:relay(.hood_total ._left a, .property_total a)': function(e, _el){
				Cookie.write('crSearchScrollPosition', 0);
			}
		})
	}
});

var LimousineAnythingExt = new Class({
	Extends: LimousineAnything,
	Implements: [Options, Events],

	options: {
		with_type_select: false, // sales or rentals
		with_advance_options: false
	},

	build: function(){
		this.parent();

		this.add_type_select();
	},

	handle_response: function(response, query_string){
		if(this._field.get('value').length < this.options.min_chars) return;

		this.clear_results();

		if(response.hood_top || response.property_top){
			this.auto_complete(query_string, (response.hood_top || response.property_top));
		}else{
			this.auto_complete(null, '');
		}

		var html = this.get_html({
			hood: response.hood,
			property: response.property,
			partial: response.partial,
			links: response.links
		});

		if(html == ''){
			this._field.fireEvent('clearResults');
			html = '<div class="no_results">No Matches Found. <span>Try neighborhood or building name (i.e. "Chelsea" or "Trump Tower")</span></div>';
		}else{
			this._field.fireEvent('gotResults');
			this._results_wrapper.addClass('has_results');
		}

		this._results.set('html', html);
		this.add_nearby_neighborhood(response.hood);

		this.submit_url = this.get_submit_url();

		this._items = this._element.getElements('.items .item');

		var _fv = this._results.getElement('.field_value');
		if(_fv) _fv.set('text', this._field.get('value'));

		this._results.show();
		this._results.fade('show');

		this.add_nh_stats_support();
		this.click_on_property_link_support();
		this.click_on_search_link_support();
	},

	add_nh_stats_support: function(){
		var self = this;

		this._items.each(function(_el){
			if(!_el || !_el.hasClass('_nh')) return;

			_el.addEvents({
				'mouseenter': function(){
					self.show_nh_stats(_el);
				},

				'mouseleave': function(){
					var _selected = self._element.getElement('.items .item.selected._nh');

					if(_selected){
						self.show_nh_stats(_selected);
					}else{
						self.show_init_nh_stats();
						self.add_nearby_neighborhood_counts();
					}
				},

				'mouseover': function(){
					_el.fireEvent('mouseenter');
				},

				'mouseout': function(){
					_el.fireEvent('mouseleave');
				}
			});
		});
	},

	get_html: function(data){
		if(this.options.with_type_select){
			this.search_type = this._type_select.getElement('select').getElement(':selected').get('value');
		}

		var links_html = this.get_links_html(data.links);
		var hoods_html = this.get_hoods_html(data.hood, data.partial, data.ga);
		var properties_html = this.get_properties_html(data.property, data.ga);

		return  links_html + hoods_html + properties_html;
	},

	get_hoods_html: function(data, partial, ga){
		var html = '';

		if(data.list.length == 0 && !partial){
			this._results.removeClass('_full');
		}else{
			var total = this.get_hoods_total(data.total, data.url, ga);

			var type = data.list[0]? data.list[0].type : 'hood';

			if(!partial){
				this._results.addClass('_full');
				var list = this.get_hoods_list(data.list, ga);

				if(this.options.with_advance_options){
					html =	'<div class="hood_list">' +
									'<div class="header">';

					if(type == 'hood'){
						html += 'Neighborhood Information' +  '<a class="raquo" href="/nyc">' + 'Explore All NYC Neighborhoods' + '</a>';
					}
					else{
						html += 'Matching Area(s)';
					}

					html +=	'</div>' +
									'<ul class="items">' +
										list +
									'</ul>' +
									'</div>';
				}
				else{
					html =	'<div class="hood_list">' +
										'<div class="header">' +
											(type == 'hood'? 'Neighborhood Information' : 'Matching Area(s)') +
										'</div>' +
										'<ul class="items">' +
											list +
										'</ul>' +
									'</div>';
				}
			}

			html += total;
		}

		return html;
	},

	get_hoods_list: function(data, ga){
		var opts = this.options;
		var query_string = this.get_query_string();
		var escape_query_string = RegExp.escape(query_string);
		var html = '';
		var current_zone;
		var max_item = 6; //CRTWO-2841

		data.each(function(el, i){
			if(i > max_item-1) return;

			current_zone = (el.zone? current_zone : el.id);
			var label = el.name.replace(new RegExp('(' + escape_query_string + ')', 'gi'), opts.highlight_markup.substitute({'query': '$1'}));

			var trackHood = el.zone > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + el.url.query.action + '" data-track-label="' + ga.label + '" ' : '';

			html += '<li class="item _nh' + (!el.zone? ' _zone' : '') + ((el.zone && el.zone == current_zone)? ' _shift' : '') + (el.zone? ('"data-url="' + el.url.query.url + '" data-value="' + el.name) : '') + '" data-sale="' + el.for_sale + '" data-rent="' + el.for_rent + '" data-condos="' + el.condos_coops + '" data-nofee="' + el.rentals + '">' +
								(el.zone? '<a href="' + el.url.query.url + '"': '<span') + ' class="item_value" ' + trackHood + '>' + label + (el.zone? '</a>' : '</span>') +
							'</li>';
		});

		if(data.length > max_item){
			var trackAllHoods = ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="allneighborhoods" data-track-label="' + ga.label + '" ' : '';

			html += '<li class="item _all_nh" data-url="/nyc">' + '<a href="/nyc" class="item_value" ' + trackAllHoods + '>' + 'View All Neighborhoods Matches' + '</a>' + '</li>';
		}

		return html;
	},

	get_hoods_total: function(data, url, ga){
		var trackForSale = data.for_sale > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.for_sale.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackCondosCoop = data.condos_coops > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.condos_coops.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackForRent = data.for_rent > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.for_rent.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackRentals = data.rentals > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + url.rentals.action + '" data-track-label="' + ga.label + '" ' : '';

		var html =	'<table class="hood_total">' +
							'<tr>' +
								'<td class="sales' + ((this.search_type)? ((this.search_type =='sale')? ' _show' : '') : '') + '">' +
									'<h3 class="clearfix"><span>Available Apartments' + ((this.search_type)? '' : ' - Sales') + '</span>' +
										'<a class="raquo advanced_search_link" href="' + url.for_sale_advanced + '" data-href="' + url.for_sale_advanced + '">' + 'Advanced Search</a>' +
									'</h3>' +

									'<table>' +
										'<tr>' +
											'<td class="_left">' +
												(data.for_sale > 0? ('<a class="stat" href="' + url.for_sale.url + '" data-href="' + url.for_sale_nearby + '" ' + trackForSale + '>') : '<div class="stat" data-href="' + url.for_sale_nearby + '">') +
													'<span data-initial-value="' + data.for_sale + '">' + Core.add_commas(data.for_sale) + '</span>Apts for Sale' +
												(data.for_sale > 0? '</a>' : '</div>') +
											'</td>' +

											'<td class="_right">' +
												(data.condos_coops > 0? ('<a class="stat" href="' + url.condos_coops.url + '" data-href="' + url.condos_coops_nearby + '" ' + trackCondosCoop + '>') : '<div class="stat" data-href="' + url.condos_coops_nearby + '">') +
													'<span data-initial-value="' + data.condos_coops + '">' + Core.add_commas(data.condos_coops) + '</span>Building Profiles' +
												(data.condos_coops > 0? '</a>' : '</div>') +
											'</td>' +
										'</tr>' +
									'</table>' +
								'</td>' +

								'<td class="rentals _right ' + ((this.search_type)? ((this.search_type =='rent')? ' _show' : '') : '') + '">' +
									'<h3 class="clearfix"><span>Rentals' + '</span>' +
										'<a class="raquo advanced_search_link" href="' + url.for_rent_advanced + '" data-href="' + url.for_rent_advanced + '">' + 'Advanced Search</a>' +
									'</h3>' +

									'<table>' +
										'<tr>' +
											'<td class="_left">' +
												(data.for_rent > 0? ('<a class="stat" href="' + url.for_rent.url + '" data-href="' + url.for_rent_nearby + '" ' + trackForRent + '>') : '<div class="stat" data-href="' + url.for_rent_nearby + '">') +
													'<span data-initial-value="' + data.for_rent + '">' + Core.add_commas(data.for_rent) + '</span>Apts for Rent' +
												(data.for_rent > 0? '</a>' : '</div>') +
											'</td>' +

											'<td class="_right">' +
												(data.rentals > 0? ('<a class="stat" href="' + url.rentals.url + '" data-href="' + url.rentals_nearby + '" ' + trackRentals + '>') : '<div class="stat" data-href="' + url.rentals_nearby + '">') +
													'<span data-initial-value="' + data.rentals + '">' + Core.add_commas(data.rentals) + '</span>No Fee Buildings' +
												(data.rentals > 0? '</a>' : '</div>') +
											'</td>' +
										'</tr>' +
									'</table>' +
								'</div>' +
							'<tr>' +
						'</table>';

		return html;
	},

	get_properties_html: function(data, ga){
		var html = '';

		if(data.list.length == 0) return html;

		var trackTotalForSale = data.total.for_sale > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + data.url.for_sale.action + '" data-track-label="' + ga.label + '" ' : '';
		var trackTotalForRent = data.total.for_rent > 0 && ga ? ' data-track-link="true" data-track-category="' + ga.category + '" data-track-action="' + data.url.for_rent.action + '" data-track-label="' + ga.label + '" ' : '';

		html += '<table class="property_total">' +
							'<tr>' +
								'<td class="sales ' + ((this.search_type)? ((this.search_type =='sale')? ' _show' : '') : '') + '">' +
									(data.total.for_sale > 0? ('<a class="stat" href="' + data.url.for_sale.url + '" ' + trackTotalForSale + '>') : '<div class="stat">') +
										'<span>' + Core.add_commas(data.total.for_sale) + '</span>Apts for Sale' +
									(data.total.for_sale > 0? '</a>' : '</div>') +
								'</td>' +

								'<td class="rentals ' + ((this.search_type)? ((this.search_type =='rent')? ' _show' : '') : '') + '">' +
									(data.total.for_rent > 0? ('<a class="stat" href="' + data.url.for_rent.url + '" ' + trackTotalForRent + '>') : '<div class="stat">') +
										'<span>' + Core.add_commas(data.total.for_rent) + '</span>Apts for Rent' +
									(data.total.for_rent > 0? '</a>' : '</div>') +
								'</td>' +
							'</tr>' +
						'</table>';

		html += '<div class="property_list">' +
							'<div class="header">' +
								'Building' + (data.list.length > 1? 's' : '') + ' with \'<span class="field_value"></span>\' in name (' + data.list.length + (data.list.length == 15? '+' : '') + ')' +
							'</div>' +
							'<ul class="items">';


		var query_string = this.get_query_string();
		var escape_query_string = RegExp.escape(query_string);
		var opts = this.options;

		data.list.each(function(el){
			var label = el.name_display.replace(new RegExp('(' + escape_query_string + ')', 'gi'), opts.highlight_markup.substitute({'query': '$1'}));

			html += '<li class="item"' + (el.url? (' data-url="' + el.url) : '') + '" data-value="' + el.name_address + '">' +
								(el.url? ('<a class="item_value" href="' + el.url + '">' + label + '</a>') : ('<span class="item_value">' + label + '</span>')) +
							'</li>';
		});

		var url = this._form.getAttribute('data-submit');

		if(query_string && query_string != '' && url && url != ''){
			url += query_string;
		}

		html +=		'</ul>' +
							'<a class="view_all_results raquo' + (data.total.buildings == data.list.length? ' none' : '') + '" href="' + url + '">View All Matches</a>' +
						'</div>';

		return html;
	},

	add_nearby_neighborhood: function(data){
		var self = this;
		this.data_list_expanded = data.list_expanded;

		if(data.list_expanded && data.list_expanded.length == 0) {
			if(this.hood_multiselect) this.hood_multiselect = null;

			return;
		}

		this.query_hood_id = data.list[0].id;

		var _h3 = (this.search_type == 'rent')? this._results.getElement('.hood_total .rentals h3') : this._results.getElement('.hood_total .sales h3');

		this._nearby_hoods = new Element('div',{
			'class' : 'additional_hoods_container'
		}).inject(_h3);

		var _hoods_multiselect = new Element('div',{
			'class' : 'w_multiselect',
			'data-monitor-text' : 'Include nearby Neighborhoods',
			'html' : '<ul></ul>'
		}).inject(this._nearby_hoods);

		data.list_expanded.each(function(el){
			var _li = new Element('li',{
									'data-hood-id': el.id,
									'text' : el.name
								}).inject(_hoods_multiselect.getElement('ul'));

			_li.data = el;
		})

		this.hood_multiselect = new Multiselect(_hoods_multiselect, {
			text_input: false,
			close_button: true,
			suspension_points: true,
			equality: true,
			add_tiles: false,
			onChange: function(){
				self.add_nearby_neighborhood_counts();
				self.update_links();
			},
		});

		// to make sure the neighborhood dropdown is not being cut when its open.
		this.hood_multiselect._monitor.addEvents({
			'click': function(e, i){
				var _property_list = self._results.getElement('.property_list');
				if(!_property_list || _property_list.getSize().y < 270){
					self._results_scroller.setStyle('overflow-y', 'visible');
				}
			}
		})

		this.hood_multiselect._element.addEvents({
			'mouseleave' : function(){
				self._results_scroller.setStyle('overflow-y', 'auto');
			}
		})

		this.add_main_toggle();
		this.add_click_on_div_stat_element();
	},

	add_nearby_neighborhood_counts: function(){
		if(!this.hood_multiselect) return;

		var self = this;
		var _big_numbers = this._results.getElements('.hood_total table span');
		var _selected_hoods = this.hood_multiselect._list.getElements('._selected');
		var counts_condos_coops = counts_sale = counts_rent = counts_rentals = 0;

		if(_selected_hoods.length > 0){
			_selected_hoods.each(function(_el){
				if(!_el.data) return;

				counts_condos_coops += _el.data.condos_coops.toInt();
				counts_rentals += _el.data.rentals.toInt();
				counts_sale += _el.data.for_sale.toInt();
				counts_rent += _el.data.for_rent.toInt();
			})

			this._toggle_main.addClass('_selected');
		}
		else{
			this._toggle_main.removeClass('_selected');
		}

		var counts = [counts_sale, counts_condos_coops, counts_rent, counts_rentals];

		_big_numbers.each(function(_el, i){
			if(counts[i] > 0){
				var total = _el.get('data-initial-value').toInt() + counts[i];
				_el.set('text', Core.add_commas(total));
			}
			else{
				self.show_init_nh_stats();
			}
		})
	},

	add_main_toggle: function(){
		var self = this;

		this._toggle_main = new Element('span',{
			'class' : 'main_toggle'
		})

		this._toggle_main.inject(this.hood_multiselect._monitor, 'top');

		this._toggle_main.addEvent('click', function(e){
			if(e && e.stop) e.stop();

			if(self._toggle_main.hasClass('_selected')){
				self._toggle_main.removeClass('_selected');
				self.hood_multiselect._list.getElements('li').removeClass('_selected');

				self.show_init_nh_stats();
			}
			else{
				self._toggle_main.addClass('_selected');
				self.hood_multiselect._list.getElements('li').addClass('_selected');

				self.add_nearby_neighborhood_counts();
			}

			self.update_links();
		})

		this._toggle_main.fireEvent('click'); // include nearby neighborhoods by default
	},

	update_links: function(){
		var self = this;
		var _selected_hoods = this.hood_multiselect._list.getElements('._selected');
		var _links = this._results.getElements('.hood_total .stat, .hood_total h3 a.advanced_search_link');

		if(_selected_hoods.length == 0){
			_links.each(function(_link){
				if(_link.tagName === 'DIV') {
					_link.set('data-href', _link.initial_url);
				}
				else{
					_link.set('href', _link.initial_url);
				}
			});

			return;
		}

		_selected_hoods.each(function(_hood, i){
			_links.each(function(_link){
				var url, href;

				var data_url = _link.initial_data_url || _link.get('data-href');

				if(!_link.initial_url){
					_link.initial_url = _link.get('href') || _link.get('data-href');
				}

				if(data_url.contains('?hood%5B%5D=' + self.query_hood_id) || data_url.contains('?hood[]=' + self.query_hood_id)){
					url = data_url;
				}
				else{
					url = data_url + '?hood[]=' + self.query_hood_id;
				}

				if(_link.tagName === 'DIV') {
					if(!_link.initial_data_url){
						_link.initial_data_url = _link.get('data-href');
					}

					href = (i == 0)? url : _link.get('data-href');
					href = href + '&hood[]=' + _hood.get('data-hood-id');

					_link.set('data-href', href);
				}
				else{
					href = (i == 0)? url : _link.get('href');
					href = href + '&hood[]=' + _hood.get('data-hood-id');

					_link.set('href', href);
				}
			});
		})
	},

	add_click_on_div_stat_element: function(){
		var _links = this._results.getElements('.hood_total div.stat');

		_links.each(function(_el){
			_el.addEvents({
				'click': function(e){
					if(e && e.stop) e.stop();

					if(_el.getElement('span').get('text').toInt() > 0){
						location.href = _el.get('data-href');
					}
				},
				'mouseenter': function(){
					if(_el.getElement('span').get('text').toInt() > 0){
						_el.addClass('_hover');
					}
				},
				'mouseleave': function(e){
					_el.removeClass('_hover');
				}
			})
		})
	},

	add_type_select: function(){
		var self = this;

		this._type_select = this._element.getElement('.w_styled_select._type');

		if(!this._type_select) return;

		this._type_select.addEvent('click', function(e){
			if(e && e.stop) e.stop();
		})

		this._type_select.getElement('select').addEvent('change', function(_el){
			self._results.getElements('.rentals, .sales').each(function(_el){
				_el.toggleClass('_show');
			});

			if(_el.hasClass('rent')){
				self.search_type = 'rent';

				if(self._nearby_hoods && self.data_list_expanded.length > 0){
					self._nearby_hoods.inject(self._results.getElement('.hood_total .rentals h3'));
				}
			}
			else{
				self.search_type = 'sale';

				if(self._nearby_hoods && self.data_list_expanded.length > 0){
					self._nearby_hoods.inject(self._results.getElement('.hood_total .sales h3'));
				}
			}
		});
	}
});

var LimousineArchive = new Class({
	Extends: LimousineExt,

	do_query: function(){
		var opts = this.options;
		var query_string = this.get_query_string();
		this.current_query_string = this.current_string = query_string;

		if(query_string == opts.over_text || query_string.length == 0){
			this.fireEvent('emptyQuery', [this]);
			return this.clear_results();
		}else if(query_string.length < opts.min_chars){
			return this;
		}

		this._element.addClass('loading');
		this.fireEvent('doQuery',[query_string]);

		return this;
	},

	handle_blur: function(e){
		// check if input value has complete value of 1st item -> if not-> erase the text field
		var opts = this.options;

		if(this._field.get('value').toString().trim() == '') {
			this._field.addClass('inactive').set('value', opts.over_text);

			if(this._key_field != null){
				this._key_field.set('value', '');
			}
		}

		if(this._key_field != null && this._key_field.get('value') == ''){
			this._field.set('value', '');
		}

		//this.timer = this.clear_results.delay(300, this);
		this.fireEvent('textfieldBlur', [this]);
	},

	clear_results: function(){
		this.current_query_string = null;

		this.fireEvent('clearResults');

		return this;
	},
});


var LimousineBrokerSearch = new Class({
	Extends: LimousineExt,
	Implements: [Options, Events],

	handle_response: function(response_text, query_string) {
		var json_obj = response_text;

		if (typeOf(response_text) === 'string') {
			json_obj = this.format_response(response_text);
		}

		this.fireEvent('handleResponse', [json_obj]);
	}
})
